import { MapInformationService } from '../../../services/map-information.service'
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { NavbarSidebarComponent } from 'src/app/shared/navbar-sidebar/navbar-sidebar.component';


@Component({
  selector: 'app-simple-view-commissioning',
  templateUrl: './simple-view-commissioning.component.html',
  styleUrls: ['./simple-view-commissioning.component.scss']
})
export class SimpleViewCommissioningComponent implements OnInit {

  @ViewChild('componentNavBar', { static: false }) componentNavBar: NavbarSidebarComponent;

  helpCardsVisible: boolean = false;
  startHereCardsVisible: boolean = false;
  salesCardsVisible: boolean = false;
  otherCardsVisible: boolean = false;
  inventoryCardsVisible: boolean = false;
  userCardsVisible: boolean = false;

  menu:any[]=[]

  datacards:any[]=[]

  showMenuNavbar:boolean = false
  public moduloName:any=""

  currentUrl: string;


  constructor(
    private MapInformationService:MapInformationService,
    private activatedRoute: ActivatedRoute,
    public userService: UserService,
    private router: Router,
  ) { 

    
    // this.getMenu()
    this.moduloName = activatedRoute.snapshot.queryParamMap.get("moduleName");
    this.ngOnInit()

  }
  
  showCardHelp:boolean=false
  ngOnInit() {
    this.GetGettingStarted();
    this.GetURLTraining();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // this.currentUrl = event.url;
        const ruta = (<any>event).url.split("/").slice(-1)[0];
        const cards = ruta.split("=")
        if (cards[1] != undefined){
          this.moduloName = cards[1]
          if (cards[1] == "Help"){
            this.showCardHelp = true
          } else {
            this.showCardHelp = false
            this.getCards()
          }
        }
      }
    })
  }

  public getCards(){
    const dataMenu = (JSON.parse(localStorage.getItem('userMenu')).userMenuNodes)
    this.moduloName = decodeURIComponent(this.moduloName)

    this.datacards = dataMenu.filter(x=>x.moduleName == this.moduloName)[0].userModules
  }

  showLinksOrURL(data){
    this.helpCardsVisible = false;
    this.startHereCardsVisible = false;
    if (data.cubeLink == "NULL"){
      this.datacards = data.userModules
    } else {
      this.router.navigateByUrl(data.cubeLink);
    }
  }

  showRoute(link){
    // this.componentNavBar.isSideBarVisible = false;
    // this.componentNavBar.dontShow = true

    this.router.navigateByUrl(link);
  }


  GoToZD() {
    this.userService.getZDUserToken().subscribe(result => {
      window.open("https://cube-usa-edge.zendesk.com/access/jwt?jwt=" + result.ztoken, "_blank");
    });
  }

  urlTraining: string;
  GetURLTraining() {
    let info = {
      method: "Get_ClientSettingsByName",
      name: "CubeUniversity"
    }
    this.MapInformationService.SaveInfoSites(info).subscribe(
      (response) => {
        console.log('Response from GetURLTraining:', response);
        if (response.length > 0) {
          this.urlTraining = response[0].VALUE;
        }
      }
    )
  }

  urlGettingStarted: string;
  GetGettingStarted() {
    let info ={
      method: "Get_ClientSettingsByName",
      name: "LinkGettingStarted"
    }
    this.MapInformationService.SaveInfoSites(info).subscribe(
      (response) => {
        console.log('Response from GetGettingStarted:', response);
        if (response.length > 0) {
          this.urlGettingStarted = response[0].VALUE;
        }
      }
    )
  }

}
